import { render, staticRenderFns } from "./list_column.vue?vue&type=template&id=0f346fce&"
import script from "./list_column.vue?vue&type=script&lang=js&"
export * from "./list_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports